import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { toggleFacetInFilterBy, addUniqFacetInFilterBy } from '~/helpers/filter-helper';
import * as types from './types';
export default {
  [types.SET_DEFAULT_ORDERBY](state, payload) {
    const currentState = state;
    currentState.orderBy = payload;
  },

  [types.SET_DEFAULT_SORTBY](state, payload) {
    const currentState = state;
    currentState.sortBy = payload;
  },

  [types.SET_DEFAULT_FILTERBY](state, payload) {
    const currentState = state;
    currentState.filterBy = payload;
  },

  [types.SORT_BY](state, payload) {
    const currentState = state;
    currentState.sortBy = payload;
  },

  [types.ORDER_BY](state, payload) {
    const currentState = state;
    currentState.orderBy = payload;
  },

  [types.FILTER_BY](state, _ref) {
    let {
      filter,
      facet,
      uniq = false
    } = _ref;
    const currentState = state;
    const transform = uniq ? addUniqFacetInFilterBy : toggleFacetInFilterBy;
    currentState.filterBy = transform(_objectSpread({}, currentState.filterBy), filter, facet);
  },

  [types.RESET_FILTERS](state) {
    const currentState = state;
    currentState.filterBy = null;
  },

  [types.RESET_PAGINATION](state) {
    const currentState = state;
    currentState.previousPage = 1;
    currentState.nextPage = 1;
  },

  [types.SET_NEXT_PAGE](state, payload) {
    const currentState = state;
    currentState.nextPage = payload;
  },

  [types.SET_PREVIOUS_PAGE](state, payload) {
    const currentState = state;
    currentState.previousPage = payload;
  }

};